<template>
    <div class="container text-center container_bg">
    <h2 class="pt-6">保函样张确认</h2>
    <Step :arr="arr" class="mt-6 mb-6"></Step>
    <div style="width: 80%; margin: 0 auto">
      <PDFRender :url="url" />
    </div>
     <div class="pay">
   <!--   <el-button
      type="primary"
      class="mt-3 mb-3"
      @click="handleBack"
      >返回</el-button
    > -->
    <el-button
      type="primary"
      class="mt-3 mb-3"
      @click="handlePay"
      >支付</el-button
    >
    </div>
  </div>

</template>

<script>
import Step from '../../../../components/CA/Step'
import pdf from '@/components/pdf/pdf'
import { pay } from '@/shared/pay'
import store from '../mixins/store'
import { queryModePayment } from '@/api/comm'

export default {
  data() {
    return {
      arr: [
        { icon: 1, span: '保函样张确认', status: 'finish', time: '' },
        { icon: 2, span: '订单支付', status: 'active', time: '' },
      ],
      paymentType: '',
      orderId:'',
    }
  },
  mixins: [store],
  components: {
    Step,
    PDFRender: pdf,
  },
  computed: {
    url() {
      return `/zcjf/base/file/download/${this.$route.query.pdfId}`
    },
  },
  beforeMount() {
    this.orderId = this.$route.query.orderId
    //查询支付方式
    queryModePayment({
      orderId:  this.orderId,
    }).then((res) => {
      if (res.data) {
        this.paymentType = res.data
        if (this.paymentType === '0') {
          this.arr[1].span = '订单支付'
        } else {
          this.arr[1].span = '上传电汇底单'
        }
      }
    })
  },
  methods: {
    handleBack() {
      this.$router.replace({
        path:this.$route.query.backType,
        query: {
          ...this.$route.query,
          orderID: this.orderId,
        },
      })
    },
    handlePay() {
      this.clear()
      if (this.paymentType && this.paymentType === '1') {
            // 线下支付
            this.$router.push({
              path: '/wire-transfer',
              query: {
                order: this.orderId,
              },
            })
          } else {
            pay.call(this, this.orderId)
          }        
    },
  },
}
</script>

<style lang="less" scoped>
.pay {
  text-align: center;
  margin-top: 20px;
  padding-bottom: 20px;
  /deep/ button {
    padding: 20px;
    width: 130px;
    font-size: 20px;
  }
}
</style>
